export interface Player {
  url: string;
  alt: string;
  ratio: number;
  name: string;
  country: string;
  team: string;
  teamCountry: string;
}

export const players: Player[] = [
  {
    url: process.env.PUBLIC_URL + "/images/players/carl_johansson_600x720.webp",
    alt: "",
    ratio: 5 / 6,
    name: "Carl Johansson",
    country: "se",
    team: "Holstein Kiel",
    teamCountry: "de",
  },
  {
    url: process.env.PUBLIC_URL + "/images/players/oliver_berg_400x480.webp",
    alt: "",
    ratio: 5 / 6,
    name: "Oliver Berg",
    country: "no",
    team: "Malmö FF",
    teamCountry: "se",
  },
  {
    url:
      process.env.PUBLIC_URL + "/images/players/karl_gunnarsson_625x750.webp",
    alt: "",
    ratio: 5 / 6,
    name: "Karl Gunnarsson",
    country: "se",
    team: "Västerås SK",
    teamCountry: "se",
  },
  {
    url: process.env.PUBLIC_URL + "/images/players/jens_magnusson_625x750.webp",
    alt: "",
    ratio: 5 / 6,
    name: "Jens Magnusson",
    country: "se",
    team: "Västerås SK",
    teamCountry: "se",
  },
  {
    url:
      process.env.PUBLIC_URL + "/images/players/mathias_karlsson_440x528.webp",
    alt: "",
    ratio: 5 / 6,
    name: "Mathias Karlsson",
    country: "se",
    team: "GAIS",
    teamCountry: "se",
  },
];
